<script setup lang="ts">
import {ref} from "vue";
import {useRouter} from "vue-router";
import {logOut as apiLogOut} from "@/Services/auth";
import {Button} from "@/Components/Library";
import {useMainStore} from "@/Stores/store";
import {Icon} from "@iconify/vue";

const $store = useMainStore();
const router = useRouter();
const emit = defineEmits("navigate");
const menuItems = ref([
    {
        label: "Dashboard",
        icon: "prime:home",
        route: "admin.dashboard",
    },
    {
        label: "Users",
        icon: "prime:user",
        route: "admin.users.index",
    },
    {
        label: "Groups",
        icon: "prime:users",
        route: "admin.groups.index",
    },
    {
        label: "Questions",
        icon: "prime:question",
        route: "admin.questions.index",
    },
    {
        label: "Stimuli",
        icon: "prime:image",
        route: "admin.stimuli.index",
    },
    {
        label: "Invitations",
        icon: "prime:envelope",
        route: "admin.invitations.index",
    },
    {
        label: "Plans",
        icon: "prime:credit-card",
        route: "admin.plans.index",
    },
    {
        label: "Audits",
        icon: "prime:history",
        route: "admin.audits.index",
    },
    {
        label: "AI Prompts",
        icon: "prime:code",
        route: "admin.ai-prompts.index",
    },
    {
        label: "Tags",
        icon: "prime:tags",
        route: "admin.tags.index",
    },
    {
        label: "Settings",
        icon: "prime:cog",
        route: "admin.settings.index",
    },
    // {
    //     label: "Feed",
    //     icon: "prime:list",
    //     route: "feed",
    //     target: "_blank",
    // },
    // {
    //     label: 'Login',
    //     icon: 'prime:search',
    //     route: '/login',
    // }
]);

const logOut = async () => {
    try {
        if (!confirm("Are you sure you want to log out?")) {
            return;
        }
        await apiLogOut();
        sessionStorage.removeItem("user");
        router.push("/login");
    } catch (e) {
        console.log(e);
    }
};
</script>
<template>
    <div
        class="fixed left-0 top-0 z-50 flex h-dvh flex-col bg-stone-800 px-3 pb-3 pt-2 text-stone-400 transition-all lg:shadow-none"
        :class="[
            $store.show.expandedSidebar ? '-ml-0 w-60 shadow-2xl shadow-stone-950 lg:w-80' : '-ml-20 lg:ml-0 lg:w-16',
        ]"
    >
        <div class="align-center mb-4 flex h-14 items-center border-b border-stone-700 pb-1">
            <div v-if="$store.show.expandedSidebar" class="ml-5">
                <h1 class="text-3xl font-black tracking-[-0.175rem] text-stone-400">ASKr</h1>
            </div>
            <div :class="{'ml-auto': $store.show.expandedSidebar}">
                <Button
                    :icon="{
                        icon: 'material-symbols:chevron-right-rounded',
                        width: 32,
                    }"
                    class="!px-1 transition hover:bg-stone-950 active:bg-transparent"
                    :class="{'rotate-180 transform': $store.show.expandedSidebar}"
                    @click="$store.show.expandedSidebar = !$store.show.expandedSidebar"
                />
            </div>
        </div>
        <div class="flex grow flex-col overflow-hidden">
            <div class="w-full">
                <template v-for="item in menuItems">
                    <RouterLink :to="{name: item.route}">
                        <div
                            :class="{
                                'bg-askr-green-500 text-white': router.currentRoute.value.name === item.route,
                                'hover:bg-stone-950': router.currentRoute.value.name !== item.route,
                                'w-10 justify-center px-2': !$store.show.expandedSidebar,
                                'justify-start px-3': $store.show.expandedSidebar,
                            }"
                            class="-border relative mb-2 flex items-center overflow-hidden rounded-md py-3 text-xs font-bold uppercase"
                            @click="emit('navigate')"
                        >
                            <Icon :icon="item.icon" width="20" />
                            <span v-show="$store.show.expandedSidebar" class="ml-3">{{ item.label }}</span>
                        </div>
                    </RouterLink>
                </template>
            </div>
            <div class="mt-auto">
                <RouterLink :to="{name: 'feed'}">
                    <div
                        :class="{
                            'bg-askr-green-500 text-white': router.currentRoute.value.name === 'feed',
                            'hover:bg-stone-950': router.currentRoute.value.name !== 'feed',
                            'w-10 justify-center px-2': !$store.show.expandedSidebar,
                            'justify-start px-3': $store.show.expandedSidebar,
                        }"
                        class="-border relative mb-2 flex items-center overflow-hidden rounded-md py-3 text-xs font-bold uppercase"
                        @click="emit('navigate')"
                    >
                        <Icon icon="prime:list" width="20" />
                        <span v-show="$store.show.expandedSidebar" class="ml-3">Feed</span>
                    </div>
                </RouterLink>
                <button
                    @click="logOut"
                    class="-border relative mb-2 flex w-full items-center overflow-hidden rounded-md py-3 text-xs font-bold uppercase hover:bg-stone-950"
                    :class="{
                        'w-10 justify-center px-2': !$store.show.expandedSidebar,
                        'justify-start px-3': $store.show.expandedSidebar,
                    }"
                >
                    <Icon icon="prime:sign-out" width="20" />
                    <span class="ml-3" v-if="$store.show.expandedSidebar">Log out</span>
                </button>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
